import { Injectable } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { ROUTEPERMISSIONS } from "../enums/route-permissions";
import { AuthService } from "#root/core/auth/auth.service";

@Injectable({
  providedIn: "root",
})
export class PermissionRouterService {
  constructor(private readonly router: Router, private readonly authService: AuthService) {}

  initPermissionWatcher(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const url = event.url;
        const cleanUrl = url.split("?")[0].split("#")[0]; // Por si hay query o fragmento

        const permissionConfig = ROUTEPERMISSIONS[cleanUrl];

        if (!permissionConfig) {
          // Ruta sin restricción => permitir
          return;
        }

        const permissionsMap =
          this.authService.loggedInUserSnapshot?.permissionsMap;
        if (!permissionsMap) {
          // Bloquea si no hay permisos
          this.router.navigateByUrl("/error/403");
          return;
        }

        const requiredPermissions = permissionConfig.permissions;
        const mode = permissionConfig.mode;

        const hasPermission =
          mode === "any"
            ? requiredPermissions.some((p) => permissionsMap[p])
            : requiredPermissions.every((p) => permissionsMap[p]);

        if (!hasPermission) {
          // Cancela la navegación y redirige
          this.router.navigateByUrl("/error/403");
        }
      });
  }
}
